/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
*/

import { DateComponent } from './../rt-date/date.component';

export class DateCellComponent extends DateComponent {
  public static NgInputs = ['time' as const, 'tooltipPosition' as const];
}
